/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TooLate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TooLate({
  children,
  viewPath = "/DesignSystem/CheckIn/Confirmation/Content/CheckInCriteria/Content/TooLate"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let checkInAlertsCriteriaIsPatientTooLateValueData = fromData.useDataValue({ viewPath,
context: 'check_in',
path: 'alerts.criteria.is_patient_too_late',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(checkInAlertsCriteriaIsPatientTooLateValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}